"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCloseCircleOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.9 6.1A14 14 0 006.1 25.9 14 14 0 0025.9 6.1zm-1.41 18.39a12 12 0 110-17 12 12 0 010 17z" }),
        React.createElement("path", { d: "M19.54 11.05L16 14.59l-3.54-3.54-1.41 1.41L14.59 16l-3.54 3.54 1.41 1.41L16 17.41l3.54 3.54 1.41-1.41L17.41 16l3.54-3.54-1.41-1.41z" })));
}
exports.default = SvgCloseCircleOutline;
//# sourceMappingURL=CloseCircleOutline.js.map